import { create } from 'zustand'
import type { TurmaDetalhes } from '@/types'
import * as turmasApi from '@/api/turmas'

interface TurmaDetalheState {
  turma: TurmaDetalhes | null
  loading: boolean
  error: string | null
  carregar: (turmaId: number) => Promise<void>
  cancelar: () => Promise<void>
  trocarArquivo: (arquivo: File) => Promise<void>
}

export const useTurmaDetalheStore = create<TurmaDetalheState>((set, get) => ({
  turma: null,
  loading: false,
  error: null,
  carregar: async (turmaId) => {
    set({ loading: true, error: null })
    try {
      const turma = await turmasApi.getTurma(turmaId)
      set({ turma })
    } catch {
      set({ error: 'Não foi possível carregar esta turma.' })
    } finally {
      set({ loading: false })
    }
  },
  cancelar: async () => {
    const turma = get().turma
    if (!turma) return
    await turmasApi.cancelarSolicitacao(turma.id)
    set({ turma: null })
  },
  trocarArquivo: async (arquivo) => {
    const turma = get().turma
    if (!turma) return
    const atualizada = await turmasApi.trocarArquivo(turma.id, arquivo)
    set({ turma: { ...turma, ...atualizada } })
  },
}))
